import { request } from './api-client';
import { HelpArticleSchema, type HelpAudience } from './schemas';
import { z } from 'zod';

const HelpArticlesSchema = z.array(HelpArticleSchema);

/**
 * The guide for one audience, already in reading order.
 *
 * Unpaginated, unlike every other collection in this client. The exception is the server's and it is
 * deliberate: a guide is read with a contents list beside it, and a reader who cannot see what else
 * is there has lost most of the value of having one.
 */
export function listHelpArticles(audience: HelpAudience) {
  return request(`/api/v1/help/articles?audience=${audience}`, HelpArticlesSchema);
}
